(function () {
  function getSelectedVariantId(bar) {
    // Prefer whatever the page's own product form currently has selected,
    // so the sticky bar always matches the real variant picker.
    var mainForm = document.querySelector('form[action*="/cart/add"]');
    if (mainForm) {
      var field = mainForm.querySelector('[name="id"]');
      if (field && field.value) return field.value;
    }
    return bar.getAttribute('data-default-variant-id');
  }

  function getSelectedQuantity() {
    var mainForm = document.querySelector('form[action*="/cart/add"]');
    if (mainForm) {
      var qtyField = mainForm.querySelector('[name="quantity"]');
      if (qtyField && qtyField.value) {
        var n = parseInt(qtyField.value, 10);
        if (!isNaN(n) && n > 0) return n;
      }
    }
    return 1;
  }

  function getVariantData(bar, variantId) {
    var script = document.querySelector('[data-buy-bar-variants-' + bar.getAttribute('data-section-id') + ']');
    if (!script) return null;
    try {
      var variants = JSON.parse(script.textContent);
      return variants.find(function (v) { return String(v.id) === String(variantId); }) || null;
    } catch (e) {
      return null;
    }
  }

  function refreshBarState(bar) {
    var variantId = getSelectedVariantId(bar);
    var variant = getVariantData(bar, variantId);
    var cartBtn = bar.querySelector('[data-buy-bar-add-to-cart]');
    var buyBtn = bar.querySelector('[data-buy-bar-buy-now]');
    var addToCartText = bar.getAttribute('data-add-to-cart-text');
    var soldOutText = bar.getAttribute('data-sold-out-text');

    if (!variant) return;

    var available = variant.available;
    [cartBtn, buyBtn].forEach(function (btn) {
      if (!btn) return;
      btn.disabled = !available;
    });

    var cartLabel = cartBtn ? cartBtn.querySelector('[data-btn-label]') : null;
    if (cartLabel) {
      cartLabel.textContent = available ? addToCartText : soldOutText;
    }
  }

  function showError(bar, message) {
    var errorEl = bar.querySelector('[data-buy-bar-error]');
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.hidden = false;
    window.clearTimeout(errorEl._hideTimer);
    errorEl._hideTimer = window.setTimeout(function () {
      errorEl.hidden = true;
    }, 4000);
  }

  function setButtonBusy(btn, busyText, isBusy) {
    if (!btn) return;
    var label = btn.querySelector('[data-btn-label]');
    if (isBusy) {
      btn.dataset.originalLabel = label ? label.textContent : '';
      if (label) label.textContent = busyText;
      btn.disabled = true;
    } else {
      if (label && btn.dataset.originalLabel !== undefined) label.textContent = btn.dataset.originalLabel;
      btn.disabled = false;
    }
  }

  function openCartDrawer(bar) {
    var customSelector = bar.getAttribute('data-drawer-selector');

    // 1) Dawn / Dawn-based themes: a <cart-drawer> custom element with a
    //    native .open() method — matches the cart-drawer.liquid snippet.
    var drawerEl = document.querySelector('cart-drawer');
    if (drawerEl && typeof drawerEl.open === 'function') {
      drawerEl.open();
      return;
    }

    // 2) A merchant-specified selector (their own cart icon, a custom
    //    drawer trigger, etc).
    if (customSelector) {
      var customEl = document.querySelector(customSelector);
      if (customEl) {
        customEl.click();
        return;
      }
    }

    // 3) Common fallbacks seen across Shopify themes.
    var fallbackSelectors = [
      '#cart-icon-bubble',
      '[data-cart-drawer-toggle]',
      '[data-cart-icon]',
      'a[href$="/cart"]'
    ];
    for (var i = 0; i < fallbackSelectors.length; i++) {
      var el = document.querySelector(fallbackSelectors[i]);
      if (el) {
        el.click();
        return;
      }
    }
  }

  function refreshCartSections(data) {
    if (!data || !data.sections) return;

    if (data.sections['cart-drawer']) {
      var drawerContainer = document.querySelector('#CartDrawer');
      if (drawerContainer) {
        var parsed = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
        var freshInner = parsed.querySelector('#CartDrawer');
        if (freshInner) drawerContainer.innerHTML = freshInner.innerHTML;
      }
    }

    if (data.sections['cart-icon-bubble']) {
      var bubble = document.querySelector('#cart-icon-bubble');
      if (bubble) {
        var parsedBubble = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
        var freshBubble = parsedBubble.querySelector('#cart-icon-bubble');
        if (freshBubble) bubble.innerHTML = freshBubble.innerHTML;
      }
    }
  }

  function addToCart(bar) {
    var variantId = getSelectedVariantId(bar);
    var quantity = getSelectedQuantity();
    var addUrl = bar.getAttribute('data-cart-add-url');

    var payload = {
      items: [{ id: variantId, quantity: quantity }],
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: bar.getAttribute('data-product-url') || window.location.pathname
    };

    return fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) {
          // Shopify's cart/add.js returns { status, message, description }
          // on error (e.g. sold out, quantity limit).
          throw new Error(data.description || data.message || bar.getAttribute('data-error-text'));
        }
        refreshCartSections(data);
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: data }));
        return data;
      });
  }

  function setup(bar) {
    if (bar.dataset.buyBarInit === 'true') return;
    bar.dataset.buyBarInit = 'true';

    var cartBtn = bar.querySelector('[data-buy-bar-add-to-cart]');
    var buyBtn = bar.querySelector('[data-buy-bar-buy-now]');
    var addingText = bar.getAttribute('data-adding-text');
    var errorText = bar.getAttribute('data-error-text');
    var openDrawer = bar.getAttribute('data-open-drawer') === 'true';

    if (cartBtn) {
      cartBtn.addEventListener('click', function () {
        setButtonBusy(cartBtn, addingText, true);
        addToCart(bar)
          .then(function () {
            setButtonBusy(cartBtn, addingText, false);
            if (openDrawer) openCartDrawer(bar);
          })
          .catch(function (err) {
            setButtonBusy(cartBtn, addingText, false);
            showError(bar, err.message || errorText);
          });
      });
    }

    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        setButtonBusy(buyBtn, addingText, true);
        addToCart(bar)
          .then(function () {
            window.location.href = bar.getAttribute('data-checkout-url');
          })
          .catch(function (err) {
            setButtonBusy(buyBtn, addingText, false);
            showError(bar, err.message || errorText);
          });
      });
    }

    // Keep price / sold-out state in sync as the shopper changes options
    // on the page's own variant picker.
    var mainForm = document.querySelector('form[action*="/cart/add"]');
    if (mainForm) {
      mainForm.addEventListener('change', function () {
        window.setTimeout(function () { refreshBarState(bar); }, 50);
      });
    }
    document.addEventListener('variant:change', function () { refreshBarState(bar); });

    /* ---------------- page-content spacing + visibility ---------------- */
    var addSpacing = bar.getAttribute('data-add-content-spacing') === 'true';
    var respectSafeArea = bar.getAttribute('data-respect-safe-area') === 'true';
    bar.setAttribute('data-respect-safe-area', respectSafeArea ? 'true' : 'false');

    function isVisible() {
      return window.getComputedStyle(bar).display !== 'none';
    }

    function applySpacing() {
      if (!addSpacing) return;
      if (isVisible()) {
        document.documentElement.style.setProperty('--sticky-buy-bar-space', bar.offsetHeight + 'px');
        document.body.classList.add('has-sticky-buy-bar-spacing');
      } else {
        document.body.classList.remove('has-sticky-buy-bar-spacing');
        document.documentElement.style.setProperty('--sticky-buy-bar-space', '0px');
      }
    }

    applySpacing();
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(applySpacing, 150);
    });
  }

  function initAll(scope) {
    var bars = (scope || document).querySelectorAll('[data-sticky-buy-bar]');
    bars.forEach(setup);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var bar = event.target.querySelector('[data-sticky-buy-bar]');
    if (bar) bar.dataset.buyBarInit = '';
    initAll(event.target);
  });
})();